var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxUnclickable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.543457,
    width: 25,
    height: 25,
    rx: 3.5,
    fill: "#E3E3E3",
    stroke: "#C7C7C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8957 18.0435L6 13.3033L7.22393 12.1183L10.8957 15.6734L18.7761 8.04346L20 9.22849L10.8957 18.0435Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxUnclickable);
export default __webpack_public_path__ + "static/media/checkBoxUnclickable.8435c20c46f30526a2f6603306116fbb.svg";
export { ForwardRef as ReactComponent };